module.exports = __webpack_public_path__ + "img/slider_conjunto.9a21aeb7.webp";